import { FC, useState } from 'react';
import ACHForm, { ACHBlurred, defaultBlurred } from 'dibs-ach-form/exports/ACHForm';
import achValidate from 'dibs-ach-form/exports/ACHValidate';
import { type AchForm, usePaymentMethodSelectContext } from '../PaymentMethodSelectContext';

type Props = {
    disabledFields?: (keyof AchForm)[];
};

export const AchPaymentForm: FC<Props> = props => {
    const { disabledFields = [] } = props;

    const [blurred, setBlurred] = useState<ACHBlurred>(defaultBlurred);

    const { achForm, updateAchForm, achFormErrors, updateAchFormErrors, isBusy } =
        usePaymentMethodSelectContext();

    function handleChange(payload: { field: string; value: string }): void {
        const { field, value } = payload;
        updateAchForm({ [field]: value });
    }

    function handleBlur(newBlurred: ACHBlurred): void {
        setBlurred(newBlurred);
        updateAchFormErrors(achValidate(achForm).fieldErrors);
    }

    // force errors to show after submit validation
    const blurredState = {
        accountType: blurred.accountType || !!achFormErrors?.accountType,
        ownershipType: blurred.ownershipType || !!achFormErrors?.ownershipType,
        routingNumber: blurred.routingNumber || !!achFormErrors?.routingNumber,
        accountNumber: blurred.accountNumber || !!achFormErrors?.accountNumber,
        firstNameOnAccount: blurred.firstNameOnAccount || !!achFormErrors?.firstNameOnAccount,
        lastNameOnAccount: blurred.lastNameOnAccount || !!achFormErrors?.lastNameOnAccount,
        businessNameOnAccount:
            blurred.businessNameOnAccount || !!achFormErrors?.businessNameOnAccount,
    };
    return (
        <ACHForm
            formValue={achForm}
            onChange={handleChange}
            blurred={blurredState}
            onBlurred={handleBlur}
            errors={achFormErrors}
            disableForm={isBusy}
            disabledFields={disabledFields}
        />
    );
};
